import { Box, Button, Container, Flex, Heading, Radio, Switch, Text, TextField } from "@radix-ui/themes"
import React, { useEffect, useState } from "react"
import FileInput from "../../components/controls/inputs/FIleInput"
import { Cross1Icon, FilePlusIcon, UploadIcon } from "@radix-ui/react-icons"
import { useNavigate, useSearchParams } from "react-router"
import useFetch from '../../core/hooks/useFetch'
import PosterService from '../../core/services/PosterService'
import {toast, ToastContainer} from 'react-toastify'
import {ROUTES} from '../../routes/constants'
import { IImage, IPoster } from "../../core/types/services-types/poster-types"
import {gen_uniq_number} from '../../utils'
import BaseModal from "../../components/controls/modals/BaseModal"
export interface FileArray {
    id: number,
    name: string,
    url: string,
    file: File
}

export default function CreatePost() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [posterId, setPosterId] = useState<string | number | null>(searchParams.get('id'))
    const [poster, setPoster] = useState<IPoster>()
    const [title, setTitle] = useState<string>('')
    const [onlyAuthorized, setOnlyAuthorized] = useState<boolean>(false)
    const [typePoster, setTypePoster] = useState<string>('news')
    const [maxSizeDescription, setbMaxSizeDescription] = useState<number>(100000)
    const [description, setDescription] = useState<string>('')
    const [oldMainFile, setOldMainFile] = useState<string | null>('')
    const [oldFiles, setOldFiles] = useState<IImage[]>([])
    const [removedFiles, setRemovedFiles] = useState<number[]>([])
    const [mainFile, setMainFile] = useState<FileArray | null>()
    const [files, setFiles] = useState<FileArray[]>([])
    const [openUploadPDFFileDialog, setOpenUploadPDFFileDialog] = useState<boolean>(false)
    const [pdfFile, setPDFFile] = useState<FileArray[]>([])
    const navigation = useNavigate()
    const [fetchCreatePoster, isLoadingCreatePoster, errorCreatePoster, errorsCreatePoster] = useFetch(async () => {
        const formData = new FormData()
        if(!title.length) {
            toast.error("Напишите название!")
            return
        }
        formData.append('title', title)
        if(!description.length) {
            toast.error("Напишите описание!")
            return
        }
        formData.append('text', description)
        formData.append('onlyAuthorized', onlyAuthorized ? '1' : '0')
        formData.append('typePoster', typePoster)
        if(mainFile) {
        formData.append('main-image', mainFile?.file, mainFile.name)
        }
        else {
            toast.error("Добавьте главное фото!")
            return
        }
        if(files.length) {
        files.forEach(file => {
            formData.append('image', file.file, file.name)
        })
    }
        if(pdfFile.length) {
            pdfFile.forEach(file => {
                formData.append('pdf', file.file, file.name)
            })
        }
        await PosterService.Create(formData)
        toast.success("Пост успешно создан!")
        navigation(ROUTES.ACCOUNT_ROUTE)
    })


    const [fetchUpdatePoster, isLoadingUpdatePost, errorUpdatePoster, errorsUpdatePost] = useFetch(async () => {
        const formData = new FormData()
        if(poster) {
        formData.append('id', poster.id.toString())
        if(!title.length) {
            toast.error("Напишите название!")
            return
        }
        formData.append('title', title)
        if(!description.length) {
            toast.error("Напишите описание!")
            return
        }
        formData.append('text', description)
        formData.append('onlyAuthorized', onlyAuthorized ? '1' : '0')
        formData.append('typePoster', typePoster)
        formData.append('delete_images', removedFiles.join(','))
        if(mainFile) {
        formData.append('main-image', mainFile?.file, mainFile.name)
        }
        else if(!oldMainFile && !mainFile) {
            toast.error("Добавьте главное фото!")
            return
        }
        if(files) {
        files.forEach(file => {
            formData.append('image', file.file, file.name)
        })
    }
    if(pdfFile.length) {
        pdfFile.forEach(file => {
            formData.append('pdf', file.file, file.name)
        })
    }
        await PosterService.Update(formData)
        toast.success("Пост успешно обновлен!")
        navigation(ROUTES.ACCOUNT_ROUTE)
    }
    })

    const actionPoster = async () => {
        if(posterId && poster) {
            await fetchUpdatePoster()
        }
        else {
            await fetchCreatePoster()
        }
    }

    const [fetchRemovePoster, isLoadingRemovePoster, errorRemovePoster, errorsRemovePoster] = useFetch(async () => {
        if(posterId) {
        const data = await PosterService.Delete(posterId)
        toast.success("Пост успешно удален!")
        navigation(ROUTES.ACCOUNT_ROUTE)
        }
    })


    const [fetchPoster, isLoadingFetchPoster, errorFetchPoster, errorsFetchPoster] = useFetch(async () => {
        if(posterId) {
        const data = await PosterService.Get(posterId)
        setPoster(data)
        setDescription(data.text)
        setTitle(data.title)
        setOldMainFile(data.main_image)
        setOldFiles(data.image)
        }
    })

    const back = () => navigation(ROUTES.ACCOUNT_ROUTE)

    const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(event)
        const files = event.target.files
        if(files) {
        const newFiles = Array.from(files).map((file) => ({
        id: gen_uniq_number(1000000, 9999999), 
          name: file.name,
          url: URL.createObjectURL(file),
          file
        }));
    
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
      };


      const handleFilesChangeDrop = (event: React.DragEvent<HTMLLabelElement>) => {
        event.preventDefault()
        const files = event.dataTransfer.files
        if(files) {
        const newFiles = Array.from(files).map((file) => ({
          id: gen_uniq_number(1000000, 9999999), 
          name: file.name,
          url: URL.createObjectURL(file),
          file
        }));
        console.log(newFiles)
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
      };

      const handleRemoveFile = (id: number) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.id !== id));
      };


      const handleRemoveOldFile = (id: number) => {
        setOldFiles((prevFiles) => prevFiles.filter((file) => file.id !== id));
        setRemovedFiles(prev => [...prev, id])
        console.log(removedFiles)
      }



      const handleMainFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if(files) {
            const file = files[0]
            if(file) {
                setMainFile({
                    id: gen_uniq_number(1000000, 999999), 
                    name: file.name,
                    url: URL.createObjectURL(file),
                    file
                })
            }
        }

      }

      const handleMainFileChangeDrop = (event: React.DragEvent<HTMLLabelElement>) => {
        event.preventDefault()
        console.log('2332')
        const files = event.dataTransfer.files
        const file = files[0]
        if(file) {
            setMainFile({
                id: gen_uniq_number(1000000, 999999), 
                name: file.name,
                url: URL.createObjectURL(file),
                file
            })
        }
      }


      const handlePDFFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if(files) {
        const newFiles = Array.from(files).map((file) => ({
        id: gen_uniq_number(1000000, 999999), 
          name: file.name,
          url: URL.createObjectURL(file),
          file
        }));
    
        setPDFFile((prevFiles) => [...prevFiles, ...newFiles]);
    }

      }

      const handlePDFFileUploadDrop = (event: React.DragEvent<HTMLLabelElement>) => {
        event.preventDefault()
        const files = event.dataTransfer.files
        if(files) {
        const newFiles = Array.from(files).map((file) => ({
          id: gen_uniq_number(1000000, 9999999), 
          name: file.name,
          url: URL.createObjectURL(file),
          file
        }));
        console.log(newFiles)
        setPDFFile((prevFiles) => [...prevFiles, ...newFiles]);
    }
    }

      const handleRemoveFilePDf = (id: number) => {
        setPDFFile((prevFiles) => prevFiles.filter((file) => file.id !== id));
      }

      const renderUploadPDFFile = (
        <Container className="change-settings-site">
          <FileInput 
          classNamelabel="w-[100%] h-[200px] mb-5"
          classNameContainer="max-w-[200px]"
          handleDrop={handlePDFFileUploadDrop}
          onChange={handlePDFFileUpload}
          accept="application/pdf,"
          contentLabel={<Text>Загрузите файл pdf</Text>}
          multiple
          />

          <Flex className="mb-5" direction={'column'} gap={'3'}>
            {pdfFile.map(file => {
                return (
                <Flex align={'center'} gap={'2'}>
               <Button color="red" onClick={() => handleRemoveFilePDf(file.id)}> <Cross1Icon /></Button> <Text>📑 {file?.name}</Text>
                </Flex>
                )
            })}
            {oldFiles.filter(file => file.type_asset === 'pdf').map(file => {
                let nameFile = file.url.split('/')
                let nameFileStr = nameFile[nameFile.length - 1]
                return (
                <Flex align={'center'} gap={'2'}>
               <Button color="red" onClick={() => handleRemoveOldFile(file.id)}> <Cross1Icon /></Button> <Text>📑 {nameFileStr}</Text>
                </Flex>
                )
            })}
          </Flex>

      </Container>
    )

    const addedVideoTagInText = (content: string) => {
        setDescription(prev => prev + " " + content)
      }

      const handleRemoveMainFile = () => setMainFile(null)

      const handleRemoveOldmainFile = () => setOldMainFile(null)

      useEffect(() => {
        if(errorUpdatePoster) toast.error(errorUpdatePoster)
      }, [errorUpdatePoster])

      useEffect(() => {
        
        if(errorCreatePoster) toast.error(errorCreatePoster)
      }, [errorCreatePoster])

      useEffect(() => {
       
        if(errorFetchPoster) toast.error(errorFetchPoster)
      }, [errorFetchPoster])

      useEffect(() => {
        if(posterId) {
           fetchPoster()
        }
      }, [posterId])


    return (
        <Container className="wrapper-creating-post p-20">
            <ToastContainer />
            <Container className="heading-creating-post mb-5">
                <Flex align={'center'} justify={'between'} wrap={'wrap'} className="mb-2"> 
                <Heading>{poster ? "Обновить пост" : "Новый пост"}</Heading>
                <Flex gap={'3'}> 
                <Button color="grass" onClick={async () => await actionPoster()} loading={isLoadingCreatePoster || isLoadingUpdatePost}>{poster ? "Обновить пост" : "Создать пост"}</Button>
                <Button color="orange" onClick={async () => await fetchRemovePoster()} loading={isLoadingRemovePoster}>Удалить пост</Button>
                </Flex>
                </Flex>
                <hr />
            </Container>
            
            <Container className="mb-5">
            <Text weight={'bold'} color="gray">
                Выберите фото на обложку
            </Text>
            <FileInput 
            id="grgtrg"
            onChange={handleMainFileChange} 
            accept="image/*" 
            contentLabel={<Flex align={'center'} justify={'center'} direction={'column'}><UploadIcon width={'30px'} height={'30px'} /> <Text weight={'bold'}>Квадратное изображение</Text> <Text>Выберите или перетащите сюда</Text> </Flex>} classNameContainer={`${mainFile || oldMainFile ? '!hidden' : '!flex'} !items-center !justify-center`} 
            classNamelabel="!min-h-[300px] !max-w-[300px]"
            handleDrop={handleMainFileChangeDrop}
            />
            <Container className="selectedMainImage">
                {mainFile ? 
                <Flex align={'center'} justify={'center'} gap={'5'}>
                <img src={`${mainFile.url}`} width={'300px'} height={'300px'} />
                <Button color="red" onClick={() => handleRemoveMainFile()}>
                    <Cross1Icon />
                </Button>
                </Flex>
                :
                oldMainFile ?
                <Flex align={'center'} justify={'center'} gap={'5'}>
                <img src={`${oldMainFile}`} width={'300px'} height={'300px'} />
                <Button color="red" onClick={() => handleRemoveOldmainFile()}>
                    <Cross1Icon />
                </Button>
                </Flex>
                :

                ''
                }
            </Container>
            </Container>
                <hr />

            <Container className="mb-5"> 
            <input placeholder="Заголовок" className="container" style={{borderWidth: '0px', outline: 'none', fontSize: '40px'}} value={title} onChange={e => setTitle(e.target.value)} />
            </Container>
            <Container className="mb-5">
                <textarea maxLength={100000} placeholder="Описание..." style={{borderWidth: '0px', outline: 'none', fontSize: '20px'}} className="h-[70vh] w-[100%] resize-none" value={description} onChange={e => setDescription(e.target.value)}/>
                <Box>
                    {description.length}/{maxSizeDescription}
                </Box>
            </Container>
            <hr />
            <Container>
            <Text color="gray" weight={'bold'}>Выберите неосновные фото</Text>
            <FileInput 
            id="fggrgr"
            onChange={handleFilesChange} 
            multiple={true}
            accept="image/*" 
            contentLabel={<Flex align={'center'} justify={'center'} direction={'column'}><UploadIcon width={'30px'} height={'30px'} /> <Text weight={'bold'}>Изображения</Text> <Text>Выберите или перетащите сюда</Text> </Flex>} classNameContainer={`!flex !items-center !justify-center`} 
            classNamelabel="!min-h-[300px] !max-w-[300px]"
            handleDrop={handleFilesChangeDrop}
            />
            <Flex wrap={'wrap'} gap={'5'} className="selected-images mt-5 mb-5">
                {files.map(item => {
                    return (
                      <Flex align={'center'} justify={'center'} gap={'5'}><img src={item.url} width={'300px'} height={'300px'} /> <Button color="red" onClick={() => handleRemoveFile(item.id)}><Cross1Icon /></Button> </Flex>
                    )
                })
            }
            {
                oldFiles.filter(file => file.type_asset === 'photo').map(item => {
                    return (
                      <Flex align={'center'} justify={'center'} gap={'5'}><img src={item.url} width={'300px'} height={'300px'} /> <Button color="red" onClick={() => handleRemoveOldFile(item.id)}><Cross1Icon /></Button> </Flex>
                    )
                })
            }
            </Flex>    
            </Container>
            <hr />

    <Heading className="mt-5 mb-5">
        Тематика
    </Heading>

    <Flex align="start" direction="column" gap="1" className="mb-5">
	<Flex asChild gap="2">
		<Text as="label" size="5">
			<Radio name="type_poster" value="news" defaultChecked onValueChange={e => setTypePoster(e)}/>
			Новости
		</Text>
	</Flex>

	<Flex asChild gap="2">
		<Text as="label" size="5">
			<Radio name="type_poster" value="important" onValueChange={e => setTypePoster(e)}/>
			Раздел важные
		</Text>
	</Flex>

	<Flex asChild gap="2">
		<Text as="label" size="5">
			<Radio name="type_poster" value="vacancy" onValueChange={e => setTypePoster(e)}/>
			Я согласен(на) на эту работу
		</Text>
	</Flex>
</Flex>

<hr />

<Heading className="mb-5 mt-5">
    Дополнительные опции
</Heading>


<Flex align={'center'} className="mt-5" gap={'3'}>
                <Switch color='green' size={'3'} checked={onlyAuthorized} onCheckedChange={e => setOnlyAuthorized(e ? true : false)}/>
                <Text size={'4'} weight={'medium'}>Только для авторизованных пользователей</Text>
 </Flex>

     <BaseModal 
                showButton={<Button className="shadow-lg !p-5 !mt-5 !mb-5"><FilePlusIcon />Загрузить PDF файл</Button>}
                title="Загрузить PDF файл"
                description={renderUploadPDFFile}
                cancelButton={<Button color="grass">Готово</Button>}
                successButton={<></>}
                open={openUploadPDFFileDialog}
                onOpenChange={setOpenUploadPDFFileDialog}
                />

<hr />

            <Flex align={'center'} gap={'5'}> 
            <Button color="grass" className="!p-5 !shadow-lg !mt-5" onClick={async () => await actionPoster()} loading={isLoadingCreatePoster || isLoadingUpdatePost}>{poster ? "Обновить пост" : "Создать пост"}</Button>
            <Button color="red" className="!p-5 !shadow-lg !mt-5" onClick={() => back()}>Отменить</Button>
            </Flex>
        </Container>
    )
}